<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/basic/Department' }">机构部门管理</el-breadcrumb-item>
            <el-breadcrumb-item>部门人员</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" size="small" :model="formInline" class="user-search">
            <el-form-item label="性别：">
                <el-select clearable v-model="formInline.sex" placeholder="请选择性别">
                    <el-option label="男" value="male"></el-option>
                    <el-option label="女" value="female"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态：">
                <el-select clearable v-model="formInline.onJob" placeholder="请选择状态">
                    <el-option label="在职" :value="true"></el-option>
                    <el-option label="离职" :value="false"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="职员姓名：">
                <el-input size="small" v-model="formInline.userNameLike" placeholder="请输入职员姓名"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" @click="search()">搜索</el-button>
                <el-button size="small" type="primary" plain @click="exportExcel()">导出列表数据</el-button>
            </el-form-item>
        </el-form>
        <div class="main-table">
            <my-table :columns="tableForm.customColumns" :tableData="tableForm.tableData" :loading="tableForm.isLoading">
            </my-table>
        </div>
        <div class="main-pagination">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
    </div>
</template>

<script>
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import { organizationName, downloadFile } from '@/utils/util.js';
import { deptMemberPage,deptList } from '@/api/dept.js'

export default {
    components: {
        MyTable,
        Pagination,
        myForm,
    },
    data () {
        return {
            formInline: {
                userNameLike: '',
                sex: '',
                onJob:'',
                deptId:'',
            },
            tableForm: {
                customColumns: [
                    { label: '所属机构', prop: 'name', formatter: () => { return organizationName } },
                    { label: '所属部门', prop: 'deptName' },
                    { label: '工号', prop: 'workNo' },
                    { label: '姓名', prop: 'userName' },
                    { label: '性别', prop: 'sex', formatter: (item) => { return item == 'male' ? '男' : '女' } },
                    { label: '岗位', prop: 'station' },
                    { label: '账号', prop: 'accountNo' },
                    { label: '身份证号', prop: 'idCard' },
                    { label: '在职状态', prop: 'onJob', formatter: (item) => { return item ? '在职' : '离职' } },
                ],

                tableData: [
                    // ...其他数据
                ],
                isLoading: false,
            },
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            deptName: ''
        }
    },
    created () {
        this.formInline.deptId = this.$route.query.deptId;
        this.deptName = this.$route.query.name;
        this.getData();
    },
    methods: {
        async getData () {
            this.tableForm.checkList = [];
            const params = {
                pageNum: this.pageparm.currentPage,
                pageSize: this.pageparm.pageSize,
                ...this.formInline,
            }
            const res = (await deptMemberPage(params)).data;
            this.tableForm.tableData = res.records;
            this.pageparm.total = res.total
        },
        callFather (parm) {
            this.pageparm.currentPage = parm.currentPage
            this.pageparm.pageSize = parm.pageSize;
            this.getData()
        },
        search () {
            this.pageparm.currentPage = 1;
            this.getData()
        },
        async exportExcel () {
            this.tableForm.checkList = [];
            const params = {
                ...this.formInline,
                pageNum:1,
                pageSize:99999,
            };
            const header = {
                responseType: 'blob',
                isExport:true
            }
            const res = (await deptMemberPage(params, header));
            downloadFile(res, 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', `${this.deptName}部门人员.xlsx`);
        }

    },

}
</script>

<style lang="scss" scoped>
.user-search {
    margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/basicData/deptUser.vue